// extracted by mini-css-extract-plugin
module.exports = {"title":"title-content-columns-module--title--1p-lS","content":"title-content-columns-module--content--3p1gi","padding":"title-content-columns-module--padding--1o-cJ"};